export const PRIORITIES = [
    {"H": "text-green-900"},
    {"P": "text-green-800"},
    {"NP": "text-green-700"},
    {"C": "text-green-600"},
    {"B": "text-green-500"}
];